import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Table, Card, Badge, Button, Spinner } from "react-bootstrap";
import api from "../../../services/api";
export default function Pages() {
  const navigate = useNavigate();
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    api
      .get("/pages/list")
      .then((ret) => {
        console.log(ret.data);
        setPages(ret.data.data);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  }, []);
  return (
    <Card className="mt-4">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <Card.Title className="fw-bold mb-0">Pages </Card.Title>

        <Button
          variant="outline-primary"
          size="sm"
          onClick={() => navigate("/cms/pages/new")}
        >
          New Page
        </Button>
      </Card.Header>
      <Card.Body>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" role="status" />
          </div>
        ) : (
          <Table bordered hover>
            <thead>
              <tr>
                <th>Title</th>
                <th>URL</th>
                <th>Visible</th>
                <th>Created At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pages.length === 0 ? (
                <tr>
                  <td colSpan={4}>No pages found</td>
                </tr>
              ) : (
                pages.map((page) => (
                  <tr key={page.id}>
                    <td>{page.title}</td>
                    <td>{page.slug}</td>
                    <td>
                      {page.display_site === 1 ? (
                        <Badge bg="success" className="me-2">
                          Site
                        </Badge>
                      ) : null}
                      {page.online === 1 ? (
                        <Badge bg="success" className="me-2">
                          App
                        </Badge>
                      ) : null}
                    </td>
                    <td>{page.date_ins}</td>
                    <td>
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => navigate("/cms/pages/" + page.id)}
                      >
                        Edit
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
}
